<div class="layout">
  <aside class="layout__sidebar">
    <ui-sidebar
      [items]="navItems"
      brand="Cmine"
      brandIcon="c"
      [collapsed]="collapsed()"
      [mobileOpen]="mobileOpen()"
      (toggleCollapsed)="toggleCollapsed()"
      (closeMobile)="closeMobile()"
    />
  </aside>

  @if (mobileOpen()) {
    <div class="layout__backdrop" (click)="closeMobile()" aria-hidden="true"></div>
  }

  <div class="layout__body">
    <header class="layout__header">
      <button
        type="button"
        class="layout__hamburger"
        aria-label="Ouvrir la navigation"
        (click)="toggleMobile()"
      >
        <ui-icon name="menu" />
      </button>

      <ui-breadcrumbs class="layout__breadcrumbs" [items]="breadcrumbs()" />

      <div class="layout__spacer"></div>

      @if (mockMode) {
        <ui-badge variant="warning">Mode démo</ui-badge>
      }

      <ui-avatar name="Mon compte" size="sm" />
      <ui-menu
        label="Mon compte"
        [items]="userMenuItems"
        (selected)="onUserMenu($event)"
      />
    </header>

    <main class="layout__content">
      <router-outlet />
    </main>
  </div>
</div>
